import styled from 'styled-components';
import { mq } from '../../theme/mediaQueries';

export const StyledForm = styled.form`
  width: 100%;
  max-width: 28rem;
  z-index: var(--z-dropdown);
`;

export const StyledAction = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-column-gap: 1rem;
`;

export const StyledProductListWrapper = styled.div`
  width: 100%;
`;

export const StyledFilterWrapper = styled.div`
  min-width: 12rem;
  z-index: 2;
`;

export const StyledWarehouseStatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--s-4);
  margin-bottom: var(--s-5);

  ${mq.ltLg} { grid-template-columns: repeat(3, 1fr); }
  ${mq.ltSm} { grid-template-columns: repeat(2, 1fr); }
`;
